import { PlusOutlined } from '@ant-design/icons';
import { message } from 'antd';
import React from 'react';

import styles from './index.module.scss';
import type { UploadImageDataType } from './types';

const getBase64 = (img: File, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => {
    const imageFileBase64Url =
      typeof reader.result === 'string' ? reader.result : '';
    callback(imageFileBase64Url);
  });
  reader.readAsDataURL(img);
};

const beforeUpload = (file: File) => {
  const isAllowedFileSize = file.size / 1024 / 1024 <= 10;
  if (!isAllowedFileSize) {
    message.error('檔案大小不得超過 10MB');
  }
  return isAllowedFileSize;
};

type UploadImageProps = {
  imageUrl: string | undefined;
  onImageChange: (uploadImageData: UploadImageDataType | undefined) => void;
};

export const UploadImage = ({ imageUrl, onImageChange }: UploadImageProps) => {
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const fileList = event.target.files;
      if (!fileList) {
        throw new Error('fileList is undefined');
      }
      if (fileList.length === 0) {
        return;
      }
      const file = fileList[0];
      const isValidFile = beforeUpload(file);
      if (!isValidFile) {
        return;
      }
      getBase64(file, (url) => {
        onImageChange({
          imageFile: file,
          previewUrl: url,
        });
      });
    } catch {
      onImageChange(undefined);
    }
  };

  return (
    <label className={styles.uploadButtonWrapper}>
      <input type="file" accept="image/*" onChange={handleImageChange} hidden />
      {imageUrl ? (
        <img src={imageUrl} alt="upload image preview" />
      ) : (
        <div className={styles.uploadButton}>
          <PlusOutlined rev={undefined} />
          <p>Upload</p>
        </div>
      )}
    </label>
  );
};
